import { selectAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { flushedFocusVisible, outlineFocusVisible } from './focus-styles';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(selectAnatomy.keys);

export const Select = defineMultiStyleConfig({
	variants: {
		outline: {
			field: outlineFocusVisible,
		},
		filled: {
			field: outlineFocusVisible,
		},
		flushed: {
			field: flushedFocusVisible,
		},
	},
});
